import * as React from "react";
import classNames from "classnames";

export const CheckboxField = field => {
    const { error, touched, dirty } = field.meta;
    const inputClasses = classNames({
        checkbox__input: true,
        dirty: dirty,
        error: error && touched
    });

    return (
        <label className={field.className || "checkbox"} htmlFor={field.id} disabled={field.disabled}>
            <input
                {...field.input}
                className={inputClasses}
                type="checkbox"
                id={field.id}
                onFocus={field.onFocus}
                onBlur={field.onBlur}
                required={field.required}
                onChange={e => {
                    field.input.onChange(e);
                    if (field.changeHandler) {
                        field.changeHandler(e);
                    }
                }}
            />
            <span className="checkbox__indicator"></span>
            <span className="checkbox__text">
                {field.label} {field.required && <span className="required-star">*</span>}
            </span>
        </label>
    );
};
